import { demoAssetsForAnyRegistry } from "./demo-assets";

export const assetsQuery = {
  read(_: any) {
    return demoAssetsForAnyRegistry.assetByAssetCode;
  },
};
